var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/es6.parse-float.js
// module id = 620
// module chunks = 0